export enum Notifier {
    SUCCESS = "success" ,
    WARNING = "warning" ,
    ERROR   = "error"   ,
    INFO    = "info"
}